import { render } from "./navbar.vue?vue&type=template&id=8bdb5c80&scoped=true"
import script from "./navbar.vue?vue&type=script&lang=js"
export * from "./navbar.vue?vue&type=script&lang=js"

import "./navbar.vue?vue&type=style&index=0&id=8bdb5c80&scoped=true&lang=css"

import exportComponent from "/prodflopclient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bdb5c80"]])

export default __exports__